/**
 * Shared upload helper used by every Power-AI upload modal on the dashboard.
 * Wraps the two-step request-upload-url / upload-bytes flow that the
 * worker exposes at /api/attachments/*.
 */
import { requestUploadUrl, uploadFileBytes } from "@/lib/files-api";

export async function uploadDocumentToStorage(
  file: File,
  entityType: string,
  sessionId: string | null | undefined,
): Promise<{ storageKey: string; size: number; filename: string }> {
  const slot = await requestUploadUrl({
    fileName: file.name,
    fileSize: file.size,
    mimeType: file.type || "application/octet-stream",
    entityType,
    // entityId is "" here because the extract endpoint will create the row
    // and link the attachment after parsing. We just need an org-scoped
    // upload slot that survives until the extract call consumes the key.
    entityId: "extract",
  }, sessionId);
  const res = await uploadFileBytes(slot.uploadUrl, file, sessionId);
  return { storageKey: res.storageKey, size: res.size, filename: file.name };
}
